import { useSelector } from 'react-redux';
import Link from 'next/link';

// styles
import styles from './shoppingbasket.module.scss';

// components
import { BUTTON_TYPES, Button } from 'components/Button/Button';
import { Icon } from 'components/Icon/Icon';
import { Translation } from 'components/Translation/Translation';

// utils
import { webshopBasketPageUrlSelector } from 'utils/selectors/globalsSelectors';
import { shoppingBasketCountSelector } from 'utils/selectors/shoppingBasketSelector';
import { queue } from 'utils/job-queue';
import { useXy } from 'utils/hooks/use-xy';
import { QUEUE_TRACK_VIEW_CART } from 'utils/tracking/track';
import { useTranslationFunction } from 'utils/hooks/use-translations';

function Notification({ show, handleClose }: { show: boolean; handleClose: () => void }) {
  const shoppingCartCount = useSelector(shoppingBasketCountSelector);
  const webshopBasketPageUrl = useSelector(webshopBasketPageUrlSelector);
  const isXy = useXy();
  const translate = useTranslationFunction();

  return show ? (
    <div className={styles.notification}>
      <div className={styles.contentWrapper}>
        {isXy
          ? <h6 className={`gdds-headline ${styles.title}`}>{translate('web20_webshop_added_to_shopping_cart')}</h6>
          : <Translation id="web20_webshop_added_to_shopping_cart" className={styles.title} />
        }
        <Button
          onClick={handleClose}
          type={BUTTON_TYPES.PLAIN}
          align="right"
          className={styles.close}
          color="#fff"
        >
          <Icon symbol="close" />
        </Button>
      </div>
      <Translation
        id="web20_webshop_basket_subtitle"
        placeholder={{ amount: shoppingCartCount.toString() }}
        className={styles.text}
      />
      <Link
        onClick={() => {
          queue.add(QUEUE_TRACK_VIEW_CART);
        }}
        href={webshopBasketPageUrl ?? ''}
      >
        <Translation id="web20_shoppingcart_label" />
      </Link>
    </div>
  ) : null;
}

export default Notification;
